module.exports = __webpack_public_path__ + "img/sassuolo.554e1a32.png";